import { render, staticRenderFns } from "./MenuHome.vue?vue&type=template&id=a97091f4&scoped=true"
import script from "./MenuHome.vue?vue&type=script&lang=js"
export * from "./MenuHome.vue?vue&type=script&lang=js"
import style0 from "./MenuHome.vue?vue&type=style&index=0&id=a97091f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97091f4",
  null
  
)

export default component.exports